<template>
  <div>
    <lp-number-input
      :model-value="inputValue"
      :preview="preview"
      format="phone"
      :helper="helper"
      :max-length="maxLength"
      :message="message"
      :disabled="disabled"
      :required="required"
      :placeholder="placeholder"
      :label-top="labelTop"
      data-ua-unique-id="unique-input"
      @update:model-value="updateModelValue"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import LpNumberInput from '@/components/numberinput'

defineOptions({
  name: 'lp-phone-input',
  inheritAttrs: false,
})

const emit = defineEmits(['update:model-value'])

interface Props {
  modelValue: number | null
  maxLength?: number
  status?: string
  message?: string | null
  helper?: string | null
  disabled?: boolean
  required?: boolean
  labelTop?: string | null
  placeholder?: string | null
  preview?: boolean | null
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  maxLength: 15,
  status: 'neutral',
  message: null,
  helper: null,
  disabled: false,
  required: false,
  labelTop: null,
  placeholder: null,
  preview: false,
})

const inputValue = computed(() => props.modelValue)
const updateModelValue = (value: number) => {
  emit('update:model-value', value)
}
</script>
